
    import { mapState } from 'vuex';
    import { OutgoingAffiliate } from '@roc/affiliate';
    import store from '../store/index';
    import BasePage from './BasePage';
    import PrelaunchPage from './PrelaunchPage.vue';

    const PAGE_NAME =  store.state.app.phase?.toLowerCase().replace(/[^a-z]+/g, '');

    export default {
        name: 'LifecyclePage',

        components: {
            OutgoingAffiliate,
            PrelaunchPage,
        },

        extends: BasePage,

        data () {
            return {
                pageName: PAGE_NAME,
            };
        },

        computed: {
            ...mapState(['app']),
            rulesLink () {
                return `<a href="${this.app.tb2URL}public/fulfillment/rules.pdf" target="_blank">${this.$t('links:rules_copy')}</a>`;
            },
        },

        i18nOptions: { namespaces: [PAGE_NAME] },
    };
